import {
  GET_USER_TRACKING_REQUEST,
  GET_USER_TRACKING_SUCCESS,
  GET_USER_TRACKING_FAIL,
  GET_INSPECTORS_REQUEST,
  GET_INSPECTORS_SUCCESS,
  GET_INSPECTORS_FAIL,
  GET_USER_TRACKING_SUMMARY_REQUEST,
  GET_USER_TRACKING_SUMMARY_SUCCESS,
  GET_USER_TRACKING_SUMMARY_FAIL,
} from "../actions/tracking";

const initialState = {
  trackingData: [],
  inspectorData: [],
  inspectors: [],
  loading: false,
  inspectorsLoading: false,
  summary: null,
};

export default function audit(state = initialState, action) {
  switch (action.type) { 
    case GET_USER_TRACKING_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_USER_TRACKING_SUCCESS:
      return {
        ...state,
        trackingData: action.payload.trackingData,
        inspectorData: action.payload.inspectorData,
        loading: false,
      };

    case GET_USER_TRACKING_FAIL:
      return {
        ...state,
        loading: false,
      };
    
    case GET_USER_TRACKING_SUMMARY_REQUEST:
      return {
        ...state,
        summaryLoading: true,
      };

    case GET_USER_TRACKING_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: action.payload,
        summaryLoading: false,
      };

    case GET_USER_TRACKING_SUMMARY_FAIL:
      return {
        ...state,
        summaryLoading: false,
      };
    
    case GET_INSPECTORS_REQUEST:
      return {
        ...state,
        inspectorsLoading: true,
      };

    case GET_INSPECTORS_SUCCESS:
      return {
        ...state,
        inspectors: action.payload,
        inspectorsLoading: false,
      };

    case GET_INSPECTORS_FAIL:
      return {
        ...state,
        inspectorsLoading: false,
      };

    default:
      return state;
  }
}
